// 2_components/breadcrumbs.js
// Tags the breadcrumbs bar with "only-home" (home + current page only) or
// "shortened" so CSS can collapse long breadcrumb trails.

export function init() {
	shortenBreadcrumbs();
}

function shortenBreadcrumbs() {
	const breadcrumbs = document.querySelector(".breadcrumbs");
	if (!breadcrumbs) {
		return;
	}
	const breadcrumbsSpans = Array.from(breadcrumbs.querySelectorAll("span[itemprop='itemListElement']"));
	if (breadcrumbsSpans.length <= 2) {
		breadcrumbs.classList.add("only-home");
	} else {
		breadcrumbs.classList.add("shortened");
	}
}
